import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import DesignCityContent from "./DesignCityContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const DesignCity = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("design.city.seo.title")} description={t("design.city.seo.des")} path="design/smart-landscape" />
      <TitleFormat text={t("design.city.title")} />
      <DesignCityContent />
    </>
  );
};

export default DesignCity;
